import { render, staticRenderFns } from "./CompanyChangeModal.vue?vue&type=template&id=8ace1154"
import script from "./CompanyChangeModal.vue?vue&type=script&lang=ts"
export * from "./CompanyChangeModal.vue?vue&type=script&lang=ts"
import style0 from "./CompanyChangeModal.vue?vue&type=style&index=0&id=8ace1154&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports